import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "vat_inventory_query_field",
      "id": "vat_inventory_query_field"
    },
    model: {
      value: _vm.searchData.code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_field", $$v);
      },
      expression: "searchData.code_field"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "vat_number"
    }
  }, [_vm._v(_vm._s(_vm.t('VAT税号')))]), _c('a-select-option', {
    attrs: {
      "value": "product_sku"
    }
  }, [_vm._v(_vm._s(_vm.t('商品编码')))]), _c('a-select-option', {
    attrs: {
      "value": "receiving_code"
    }
  }, [_vm._v(_vm._s(_vm.t('入库单/货运单号')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "data-permission": "vat_inventory_query_value",
      "id": "vat_inventory_query_value",
      "maxLength": 100
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u4ED3\u5E93"),
      "data-permission": "vat_inventory_warehouse_code",
      "id": "vat_inventory_warehouse_code",
      "show-tip": "",
      "placeholder": _vm.t('仓库')
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code
    }, [_vm._v(_vm._s(item.warehouse_name_text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "vat_inventory_date_type",
      "id": "vat_inventory_date_type",
      "value": "1"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('上架时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "vat_inventory_range_picker",
      "id": "vat_inventory_range_picker",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-permission": "vat_inventory_search",
      "id": "vat_inventory_search",
      "data-sign": "vat_inventory_query",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "vat_inventory_reset",
      "data-permission": "vat_inventory_reset",
      "id": "vat_inventory_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'vat_inventory_export',
      expression: "'vat_inventory_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "vat_inventory_export_all",
      "id": "vat_inventory_export_all",
      "data-sign": "vat_inventory_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "vat_inventory_export_selected",
      "id": "vat_inventory_export_selected",
      "data-sign": "vat_inventory_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "vat_inventory_list",
      "is-filter-box": "",
      "useMouseTool": "",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "fixed-header": "",
      "row-selection": _vm.rowSelection,
      "row-key": "rd_id",
      "name": "vatInventoryList",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "warehouse",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(record['warehouse_code']) + "[" + _vm._s(record['warehouse_name']) + "] ")]);
      }
    }, {
      key: "total_qty",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('money-format', {
          attrs: {
            "num": record.total_qty
          }
        })], 1);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "name": "vatInventoryList",
      "isFixed": "",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "orderListEsPoint": _vm.searchData.zt_list_es_point,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };